import AuthContext from '../Context/AuthProvider';
import axios from '../api/axios';
import useAuth from './UseAuth';
import { useContext,useEffect } from 'react';
// AuthContext

const useRefreshToken = () => {
    const { setAuth ,auth} = useAuth();
    // const { setAuth,auth } = useContext(AuthContext);
    

    useEffect(() => {
        console.log("auth inside useEffect:", auth);
      }, [setAuth]);

    const refresh = async () => {
        const response = await axios.get('/auth/refresh', {
        // const response = await axios.get('/refresh', {
            withCredentials: true
        });
        console.log(response)
        console.log("In use refresh",auth)
        if (response?.data?.status == "ok"){
            // setAuth({});
            // setAuth({
            //     user, roles : [roles,"test role"], accessToken, foundUser
            // });
            //  setAuth({user: "hi"});
            //  setAuth({user: "jiyaaa", roles : [response.data.roles ,"test role"], accessToken: response.data.accessToken });

            // console.log("test here",test)

            setAuth(prev => {
                console.log("Pre",JSON.stringify(prev));
                console.log("roles",response.data.accessToken);
                console.log(response.data.roles);
                return { ...prev,
                    user: response.data.email, 
                    roles : [response.data.roles ,"test role"],
                     accessToken: response.data.accessToken,
                     dat : response.data ,
                     foundUser: response.data.foundUser
                    }
                     

            });
            console.log("auths",auth)
            return response.data.accessToken;

        }
   
    }
    return refresh;
};

export default useRefreshToken;